<template>

    <header class="header header--top-position">
        <div class="header__container">
            <div class="header__content">

                <router-link to="/" class="header__logo">
                    <img src="@/assets/images/logo.png" :alt="t('sbg')">
                </router-link>

                <Menu :items="menu_items"/>

                <div class="header__plugins">
                    <Lang/>
                    <WCAG/>

                    <div class="menu-mobile-btn">
                        <span class="material-symbols-outlined" @click="menuMobileWrapperHandler('open')">menu</span>
                    </div>
                </div>

            </div>
        </div>
    </header>

    <MenuMobileWrapper
            :show="mobile_menu_show"
            :menu_items="menu_items"
            @emitMenuMobileWrapper="menuMobileWrapperHandler"/>

</template>

<script>
import axios from "@/axios"
import Menu from "@/views/Components/Menu.vue";
import Lang from "@/views/Components/Lang.vue";
import WCAG from "@/views/Components/WCAG.vue";
import MenuMobileWrapper from "@/views/Components/MenuMobileWrapper.vue";
import BackToTop from "@/views/Components/BackToTop.vue";
import Login from "@/views/Components/Login.vue";
import View from "@/views/View.vue";

export default {
    name: "Header",
    extends: View,
    components: {
        Login,
        MenuMobileWrapper,
        WCAG,
        Lang,
        Menu
    },
    mixins: [BackToTop],
    data: () => ({
        menu_items: null,
        mobile_menu_show: false,
    }),
    methods: {
        /**
         * Obsługa kliknięć otrzymanych z komponentu "MenuMobileWrapper"
         */
        menuMobileWrapperHandler(func) {

            let scrollbarWidth = window.innerWidth - document.querySelector("body").offsetWidth + "px"

            if (func === "open") {
                document.querySelector(".header").style.transition = "none"
                document.querySelector(".header").style.paddingRight = scrollbarWidth
                document.querySelector("body").style.paddingRight = scrollbarWidth
                document.body.style.overflow = "hidden"
                this.mobile_menu_show = true
            }
            if (func === "close") {
                document.querySelector(".header").style.paddingRight = "0px"
                document.querySelector("body").style.paddingRight = "0px"
                setTimeout(() => {
                    document.querySelector(".header").style.transition = "all 0.25s ease 0s"
                }, 250)
                document.body.style.overflow = "auto"
                this.mobile_menu_show = false
            }
        },

        /**
         * Pobieranie elementów menu
         */
        loadMenuItems() {

            let params = {
                code: "main",
                scope_extra: "langs"
            }

            axios
                .get("/sitemenu/positionget", {params: params})
                .then(response => {
                    this.menu_items = response.data.data.reverse()

                    /**
                     * Do usunięcia
                     */
                    this.menu_items = this.menu_items.concat([
                        {
                            id: 1001,
                            id_top_position: null,
                            title: "Aktualności",
                            code: "articles",
                            link: "/articles"
                        },
                        {
                            id: 1002,
                            id_top_position: null,
                            title: "Wydarzenia",
                            code: "events",
                            link: "/events"
                        },
                        {
                            id: 1003,
                            id_top_position: null,
                            title: "Informator",
                            code: "informator",
                            link: "/informator"
                        },
                        {
                            id: 1004,
                            id_top_position: null,
                            code: "map",
                            title: "Mapa",
                            link: "/map"
                        },
                        {
                            id: 1005,
                            id_top_position: null,
                            title: "Galerie",
                            code: "galleries",
                            link: "/galleries"
                        },
                        // {
                        //   id: 1006,
                        //   id_top_position: null,
                        //   title: "Multimedia",
                        //   link: "/multimedia"
                        // },
                        {
                            id: 1008,
                            id_top_position: null,
                            title: "Kontakt",
                            code: "contact",
                            link: "/contact"
                        }
                    ])
                })
                .catch(error => {

                })
        },
    },
    mounted() {
        this.loadMenuItems()

        let prevScrollpos = window.pageYOffset;
        let header = document.querySelector("header")

        let self = this
        window.onscroll = function () {
            let currentScrollPos = window.pageYOffset;

            // only top position
            if (currentScrollPos === 0) {
                header.classList.remove("header--first-scroll", "header--show", "header--hide")
                header.classList.add("header--top-position")
            }

            // first scroll
            if (prevScrollpos < currentScrollPos && currentScrollPos < 120) {
                header.classList.remove("header--top-position", "header--show", "header--hide")
                header.classList.add("header--first-scroll")
            }

            // show header
            if (prevScrollpos > currentScrollPos && currentScrollPos >= 120) {
                header.classList.remove("header--top-position", "header--first-scroll", "header--hide")
                header.classList.add("header--show")
            }

            // hide header
            if (prevScrollpos < currentScrollPos && currentScrollPos >= 120) {
                header.classList.remove("header--top-position", "header--first-scroll", "header--show")
                header.classList.add("header--hide")
            }

            prevScrollpos = currentScrollPos;

            // back to top
            self.scrollFunction()
        }
    }
}
</script>

<style scoped lang="scss">

$logo-val: 20px;

.header {
  position: fixed;
  width: 100%;
  height: calc(82px + $logo-val);
  top: 0;
  left: 0;
  background-color: #fff;
  box-shadow: 0 5px 20px rgb(0 0 0 / 10%);
  z-index: 9;
  transition: all 0.25s ease 0s;

  @media screen and (max-width: 991px) {
    height: calc(62px + $logo-val);
  }

  &--top-position {
    background-color: transparent;
    box-shadow: none;
    height: calc(98px + $logo-val);

    @media screen and (max-width: 991px) {
      height: calc(82px + $logo-val);
    }
  }

  &--first-scroll {
    height: calc(82px + $logo-val);

    @media screen and (max-width: 991px) {
      height: calc(62px + $logo-val);
    }
  }

  &--show {
    top: 0;
  }

  &--hide {
    top: calc(-82px - $logo-val);

    @media screen and (max-width: 991px) {
      top: calc(-62px - $logo-val);
    }
  }

  &__container {
    height: 100%;
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 12px;
  }

  &__content {
    height: inherit;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    column-gap: 16px;
  }

  &__logo {
    //width: 70px;
    //height: 70px;

    width: 250px;
    height: 90px;
    padding: 27px 0;

    //border-radius: 50%;

    @media screen and (max-width: 991px) {
      width: calc(150px + $logo-val);
      height: calc(50px + $logo-val);
      padding: 30px 0;

    }

    & img {
      width: 100%;
    }
  }

  &__plugins {
    display: flex;
    flex-direction: row;
    column-gap: 15px;
  }
}

.menu-mobile-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #646464;

  @media screen and (min-width: 992px) {
    display: none;
  }
}

html.contrast {

  & .header {
    background-color: gold;

    & .menu-mobile-btn {
      color: #000;
    }

    &--top-position {
      background-color: transparent;

      & .menu-mobile-btn {
        color: #fff;
      }
    }
  }
}

</style>